import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { StateService } from '@uirouter/angular';
import { Response } from '@angular/http/src/static_response';

@Injectable()
export class ApiService {

  constructor(
    private httpService: HttpService,
    private stateService: StateService
  ) { }

  login(userData, callbackLogin) {
    this.httpService.postData(userData, "account/login/", (response) => {
      callbackLogin(response);
    }, true);

  }

  signup(userData, callbackSignup) {
    this.httpService.postData(userData, "account/register/", (response) => {
      callbackSignup(response);
    }, true);

  }

  getUserProfile(userProfile, callbackUser) {
    this.httpService.postData(userProfile, "account/get_profile/", (response) => {
      callbackUser(response);
    }, true);

  }

  updateProfile(userUpdate, callbackUpdate) {
    this.httpService.postData(userUpdate, "account/profile_update/", (response) => {
      callbackUpdate(response);
    }, true);
  }

  sendEmailOtp(emailOtp, callbackOtp) {
    this.httpService.postData(emailOtp, "account/otp/", (response) => {
      callbackOtp(response);
    }, true);
  }

  sendPhoneOtp(phoneOtp, callbackPhoneOtp) {
    this.httpService.postData(phoneOtp, "account/otp/", (response) => {
      callbackPhoneOtp(response);
    }, true);
  }

  reportAnIncident(reportIncident, callbackReportIncident) {
    this.httpService.postData(reportIncident, "portal/suspicious_incident/", (response) => {
      callbackReportIncident(response);
    }, true);
  }

  fakeProduct(reportFake, callbackReportFake) {
    this.httpService.postData(reportFake, "/portal/fake_product/", (response) => {
      callbackReportFake(response);
    }, true);
  }

  feedBackReport(feedbackMsg, callbackfeedback) {
    this.httpService.postData(feedbackMsg, "/account/feedback/", (response) => {
      callbackfeedback(response);
    }, true);
  }

  forgotPassword(forgotchange, callbackForgot) {
    this.httpService.postData(forgotchange, "/account/forgotpassword/", (response) => {
      callbackForgot(response);
    }, true);
  }
  typeBarCode (verifyProduct, callbackProduct) {
    this.httpService.postData(verifyProduct, "/portal/product_info/", (response) => {
      callbackProduct(response);
    }, true);
  }

  externalInfo (externalProduct, callbackExternalInfo) {
    this.httpService.postData(externalProduct, "/portal/external_product_info/", (response) => {
      callbackExternalInfo(response);
    }, true);
  }

  typeCoupon (verifyCoupon, callbackCoupon) {
    this.httpService.postData(verifyCoupon, "/portal/check_coupon/", (response) => {
      callbackCoupon(response);
    }, true);
  }

  preCheck(preCheckProduct, callbackPreCheck) {
    this.httpService.postData(preCheckProduct, "/portal/oid_precheck/", (response) => {
      callbackPreCheck(response);
    }, true);
  }

  userRating (userReview, callbackUserRating) {
    this.httpService.postData(userReview, "/portal/user_rating/", (response) => {
      callbackUserRating(response);
    }, true);
  }

  userCreatedProduct (productData, callbackUserCreatedProduct) {
    this.httpService.postData(productData, "/portal/user_created_product/", (response) => {
      callbackUserCreatedProduct(response);
    }, true);
  }

  getTransactions (user_id, callbackTransactions) {
    this.httpService.postData(user_id, "/portal/transactions/", (response) => {
      callbackTransactions(response);
    }, true);
  }
  redeemCoupon (redeemCode, callbackRedeem) {
    this.httpService.postData(redeemCode, "/portal/redeem_coupon/", (response) => {
      callbackRedeem(response);
    }, true);
  }

  notifications(user_id, callbackNotification) {
    this.httpService.postData(user_id, "/portal/notifications/", (response) => {
      callbackNotification(response);
    }, true);
  }

  readTransactions(user_id, callbackReadTransactions) {
    this.httpService.postData(user_id, "/portal/transactionRead/", (response) => {
      callbackReadTransactions(response);
    }, true);
  }

  downloadTransactions(downloadOption, downloadCallBack) {
      this.httpService.downloadData(downloadOption, "portal/filtertransactions/", (response) => {
        downloadCallBack(response);
      }, true);
  }

  emailTransactions(downloadOption, downloadCallBack) {
    this.httpService.postData(downloadOption, "portal/filtertransactions/", (response) => {
      downloadCallBack(response);
    }, true);
  }

  twitterRequestToken() {
    const body = {
      "oauth_callback": window.location.origin
    };
    this.httpService.postData(body, "account/twitter_login_request/", (response) => {
      if (response.hasOwnProperty('url')) {
        window.location.href = response['url'];
      }
    }, true);
  }

  twitterLogin(body, callBack) {
    this.httpService.postData(body, "account/twitter_login/", callBack, true);
  }

  facebookLogin(fblogin, fbLoginCallback) {
    this.httpService.postData(fblogin, "account/facebook_login/", (response) => {
      fbLoginCallback(response);
    }, true);
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/services/api.service.ts